module.exports = __webpack_public_path__ + "static/media/hermes-rivera-594176-unsplash.d2e10b9f.jpg";